import { Component, OnInit } from '@angular/core';
import { paymentI } from 'app/core/interfaces/payment';
import { AuthService } from 'app/core/http/services/auth.service';
import { DialogService } from 'app/services/dialog.service';
import { PaymentDetailsComponent } from './payment-details/payment-details.component';

@Component({
  selector: 'page-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent implements OnInit {
  public methods: paymentI[] = [];
  public title = 'Formas de pagamento';

  public get methodActive(): paymentI[] {
    const methods = [...this.methods];
    return methods.filter((item: paymentI) => item.active);
  }

  public get methodInactive(): paymentI[] {
    const methods = [...this.methods];
    return methods.filter((item: paymentI) => !item.active);
  }

  constructor(
    private dialogService: DialogService,
    private readonly auth: AuthService
  ) {}

  ngOnInit(): void {
    this.getPaymentMethods();
  }

  getPaymentMethods() {
    this.methods = this.auth.getFromLocalStorage('paymentMethods');
  }

  openPaymentMethodDetail(method: paymentI) {
    const data = {
      title: method.name,
      param: { method },
    };

    this.dialogService.openComponentDialog(PaymentDetailsComponent, data);
  }
}
